import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const ScrollingBook = ({name,bookcover,webid,authorpic,summary,reads}) => {
    const navigate = useNavigate();
    const [showAbout,setShowAbout]=useState(false);
    const dialogRef = useRef();

    useEffect(()=>{
        const handleCloseSummary=(e)=>{
            if(showAbout && !dialogRef.current.contains(e.target)){
                setShowAbout(false);
            }
        }
        document.addEventListener('mousedown',handleCloseSummary);
        return()=> document.removeEventListener('mousedown',handleCloseSummary);
    },[showAbout]);

    const handleRead=()=>{
        // navigate(`/hrmwenglishbooks/${name && name.replace(/" "/g,"%20")}/${webid}`);
        navigate(`/hbrbooks?language=english&booktitle=${name}&bookid=${webid}`);
    };


    
    return (
        <div className="scrollingbook flex-colum2">
            <img src={bookcover && bookcover} id="scrollingbookimg" alt="" />
            {/* <img src={authorpic && authorpic} id="scrollingbookauthorpic" alt="" /> */}
            {reads && reads > 1 && 
                <div className="scrollingbookreads" style={{backgroundColor: "#eb268f", borderRadius:"10px", width:"auto"}}>
                    <h5 style={{color:"white", fontWeight:"bold"}}>{`${reads + ' reads'}`}</h5>
                </div>
            }
        

            <div className="flex-spacebetween" style={{position:"absolute",top:"80%",width:"100%"}}>
                <button onClick={()=>handleRead()}>Read</button>

                <div style={{position:"relative"}}>
                    <button onClick={()=>setShowAbout(prev => !prev)}>About</button>
                    {showAbout && 
                    <div className="scrollingbooksummary" ref={dialogRef} style={{
                        width:"150px",
                        height:"auto",
                        maxHeight:"100px",
                        overflowY:"auto",
                        borderRadius:"14px",
                        backgroundColor:"#1C1F2E",
                        position:"absolute",
                        bottom:"100%",
                        right:"0px",
                        left:"0px",
                        zIndex:"1",
                        padding:"10px",
                        display:"inline-block"
                        }}>
                        <pre style={{width:"90%",whiteSpace:"pre-wrap",color:"white",fontWeight:"bold"}}>
                            {summary && summary}
                        </pre>
                    </div>
                    }
                </div>
                
            </div>
        </div>
      );
}
export default ScrollingBook;